import {
	call,
	put,
	takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import EventFactory from "../../Entity/Factories/EventFactory";
import Store from "../../Store/Store";

export default function* eventsSaveList(action: ActionInterface): any {
  try {
		let request = "events?";

		typeof action.payload?.sortBy !== "undefined" ?
            request += `&sort_by=${action.payload?.sortBy}` : "sort_by=createdAt";

		typeof action.payload?.offset !== "undefined" ?
						request += `&offset=${action.payload?.offset}` : request;

		typeof action.payload?.limit !== "undefined" ?
						request += `&limit=${action.payload?.limit}` : request;

    typeof action.payload?.eventTypeId !== "undefined" ?
						request += `&event_type_ids=${action.payload?.eventTypeId}` : request;

		typeof action.payload?.eventTypeIds !== "undefined" ?
						request += "&event_type_ids=" + action.payload?.eventTypeIds.join(",") : request;

    typeof action.payload?.propertyId !== "undefined" ?
            request += `&property_id=${action.payload?.propertyId}` : request;

    typeof action.payload?.unitId !== "undefined" ?
            request += `&unit_id=${action.payload?.unitId}` : request;

    typeof action.payload?.contractId !== "undefined" ?
            request += `&contract_id=${action.payload?.contractId}` : request;

    typeof action.payload?.companyId !== "undefined" ?
            request += `&company_id=${action.payload?.companyId}` : request;

    typeof action.payload?.contactId !== "undefined" ?
            request += `&contact_id=${action.payload?.contactId}` : request;

    typeof action.payload?.chargeId !== "undefined" ?
            request += `&charge_id=${action.payload?.chargeId}` : request;

    typeof action.payload?.paymentId !== "undefined" ?
            request += `&payment_id=${action.payload?.paymentId}` : request;

    typeof action.payload?.refersToEventId !== "undefined" ?
						request += `&refers_to_event_id=${action.payload?.refersToEventId}` : request;

		typeof action.payload?.taskId !== "undefined" ?
            request += `&task_id=${action.payload?.taskId}` : request;

		typeof action.payload?.contractIds !== "undefined" ?
						request += "&contract_id=" + action.payload?.contractIds.join(",") : request;

		typeof action.payload?.removed !== "undefined" ?
						request += `&removed=${action.payload?.removed}` : request;

		typeof action.payload?.reacted !== "undefined" ?
						request += `&reacted=${action.payload?.reacted}` : request;

		typeof action.payload?.isSnoozed !== "undefined" ?
						request += `&is_snoozed=${action.payload?.isSnoozed}` : request;

		typeof action.payload?.read !== "undefined" ?
						request += `&read=${action.payload?.read}` : request;

		typeof action.payload?.filterValue !== "undefined" ?
            request += `&q=${action.payload?.filterValue}` : request;

    typeof action.payload?.executorId !== "undefined" ?
          request += `&executor_id=${action.payload?.executorId}` : request;

    typeof action.payload?.createdById !== "undefined" ?
          request += `&created_by_id=${action.payload?.createdById}` : request;

    typeof action.payload?.includeActivitiesTasks !== "undefined" ?
        !action.payload?.includeActivitiesTasks ? request += `&refers_to_event_id=` : request
        : request;

    typeof action.payload?.financialStatementId !== "undefined" ?
        request += `&financial_statement_id=${action.payload?.financialStatementId}` : request;


    // if request was done should search for info in store
		if (!Store.getConfigurator().getState().events.requestsOutdated &&
					Object.keys(Store.getConfigurator().getState().events?.requests || {}).includes(request)) {
      return action.onSuccess.call(this,
        Store.getConfigurator().getState().events.requests[request]);
    }

    const res = yield call(Http.get, request);

    const events = res.data.events.rows.map(event => {
      return EventFactory.create(event);
    });

    const payload: any = {
      events: events,
			request: request,
			count: res.data.events.count
		};

    yield put({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST_SUCCESS,
      payload: {...payload}
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, {...payload});
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchEventsSaveList() {
  yield takeEvery(Constants.GLOBAL_EVENTS_SAVE_LIST, eventsSaveList);
}
